import { __extends } from "tslib";
import { GetBucketInventoryConfigurationOutput, GetBucketInventoryConfigurationRequest } from "../models/models_0";
import { deserializeAws_restXmlGetBucketInventoryConfigurationCommand, serializeAws_restXmlGetBucketInventoryConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketInventoryConfigurationCommand = /** @class */ (function (_super) {
    __extends(GetBucketInventoryConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketInventoryConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketInventoryConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetBucketInventoryConfigurationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetBucketInventoryConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBucketInventoryConfigurationOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketInventoryConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketInventoryConfigurationCommand(input, context);
    };
    GetBucketInventoryConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketInventoryConfigurationCommand(output, context);
    };
    return GetBucketInventoryConfigurationCommand;
}($Command));
export { GetBucketInventoryConfigurationCommand };
//# sourceMappingURL=GetBucketInventoryConfigurationCommand.js.map